import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import crmAdapter from './crm.adapter';

export const {
  selectAll: crmFieldsSelector,
  selectEntities: crmFieldsEntitiesSelector,
  selectById,
} = crmAdapter.getSelectors((state: RootState) => state.crm);

export const crmFieldSelector = (fieldId?: string) => (state: RootState) => {
  if (fieldId === undefined) return null;
  return selectById(state, fieldId);
};

const crmSelector = (state: RootState) => state.crm;

export const isCrmLoadingSelector = createSelector(crmSelector, crm => crm.isLoading);

export const isCrmEditedSelector = createSelector(crmSelector, crm => crm.isEdited);

export const hasCrmErrorSelector = createSelector(crmSelector, crm => crm.hasError);

export const selectedFieldIdSelector = createSelector(crmSelector, crm => crm.selectedFieldId);

export const selectedFieldSelector = createSelector(
  [crmFieldsEntitiesSelector, selectedFieldIdSelector],
  (entities, selectedFieldId) => {
    const field = selectedFieldId ? entities[selectedFieldId] : null;
    // A column created from the clients table is selected on creation, but a
    // merchant-only one never shows on the CRM page.
    return field?.isAskedToCustomer === false ? null : field;
  },
);

export const crmSettingsSelector = createSelector(crmSelector, crm => crm.crmSettings);

export const crmNewFieldDialogOpenedSelector = createSelector(crmSelector, crm => crm.crmNewFieldDialogOpened);

/** The columns of the customer form, which the CRM page edits; merchant-only columns live in the clients table. */
export const crmFormFieldsSelector = createSelector(crmFieldsSelector, fields =>
  fields.filter(field => field.isAskedToCustomer !== false),
);

export const isCrmFormValidSelector = createSelector(crmFieldsSelector, fields => {
  return fields.every(field => field.isValid);
});
